module.exports = __webpack_public_path__ + "img/coworking_cover.01d21352.webp";